<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col style="text-align: left;width: 100%;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item size="medium">
                            <template v-for="(item,index) in stepArr">
                                <el-badge 
                                    style="margin-right: 25px;" 
                                    :value="item.JobCount" 
                                    :max="1000" 
                                    :key="index" 
                                    :hidden="item.JobCount == 0 
                                        || item.JobStepName == '已完成'
                                        || item.JobStepName == '全部'
                                        || item.JobStepName == '已取消'
                                        || item.JobStepName == '已关闭'"
                                >
                                    <el-button 
                                        size="mini" 
                                        :class="{'selected':form.JobStep == item.JobStep}"  
                                        @click="handleSearchType(item.JobStep)">
                                        {{item.JobStepName}}
                                    </el-button>
                                </el-badge>
                            </template>
                        </el-form-item>
                    </el-form>
                </el-col>
 
                <el-col style="width:200px;">
                    <el-form inline label-width="90px" label-position="left" style="text-align: right;   ">
                        <el-form-item >
                            <el-button size="medium" type="primary" class="search_btn" @click="handleSearch">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" type="success" class="search_btn" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            border
            style="width: 100%;margin-top: 20px;"
            height="640"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="工单ID">
                <el-table-column show-overflow-tooltip width="100">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.JobId" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobId || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单号">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.JobNo" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="类别">
                <el-table-column show-overflow-tooltip width="100">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.IsProjectJob" placeholder="请选择" style="width: 100%;">
                            <el-option :value="0" label="全部"></el-option>
                            <el-option :value="1" label="项目"></el-option>
                            <el-option :value="2" label="标准"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsProjectJob?'项目':'标准'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单名称">
                <el-table-column show-overflow-tooltip width="260">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.Title" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Title || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务城市">
                <el-table-column show-overflow-tooltip width="150">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="region" placeholder="请选择" @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.ProvinceName">{{scope.row.ProvinceName}} · {{scope.row.CityName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方">
                <el-table-column show-overflow-tooltip width="150">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.SenderUserName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SenderName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="上门开始时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.ExecStartDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                    <span>{{scope.row.ExecStartDate|| '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="上门结束时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.ExecEndDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                    <span>{{ scope.row.ExecEndDate || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="B2B权限">
                <el-table-column show-overflow-tooltip width="100">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.IsFreeToB2b" placeholder="请选择" style="width: 100%;">
                            <el-option :value="0" label="全部"></el-option>
                            <el-option :value="2" label="是"></el-option>
                            <el-option :value="1" label="否"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{(scope.row.IsFreeToB2b?"否":"是")}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单进度">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.SubJobStep" placeholder="请选择" style="width: 100%;" @change="SubStepChange">
                            <el-option :value="item.JobStep" :label="item.JobStepName" v-for="(item, index) in stepArr2" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobStepText || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="对接人">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.AdminUserId" placeholder="请选择" style="width: 100%;">
                            <el-option :value="item.UserId" :label="item.RealName" v-for="(item, index) in djrArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.TakeOverUserName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="销售">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.SupaiSaleAdminUserId" placeholder="请选择" style="width: 100%;">
                            <el-option :value="item.AdminUserId" :label="item.RealName" v-for="(item, index) in supaiSaleUserData" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SupaiSaleName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="linkjobInfoFun(scope.row.JobId)">详情</el-button>
                    <el-button size="mini" @click="viewRefuseInfo(scope.row.JobId)">拒单查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 服务城市 -->
        <el-dialog 
            :visible.sync="areaShow" 
            title="服务城市" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="area" label-width="60px" >
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="aid"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 48%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                    >
                        <el-option 
                            v-for="(item, index) in ProvinceIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="aid" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 48%;margin-right: 10px;" 
                    >
                        <el-option 
                            v-for="(item, index) in CityIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
    
        <!-- 拒单列表 -->
        <el-drawer
            :title="`拒单记录【工单Id:${ refuseJobId }】`"
             :visible.sync="refuseDrawer"
             direction="rtl" size="84%">
           <RefuseUserList ref="refuseUserListRef" />
        </el-drawer>

    </div>
</template>
<script>
  import RefuseUserList from './index/refuseUserList.vue'

    import {
        getJobStepList,         //获取工单列表分类
        getJobStatusList,       //获取工单状态
        getTakeOverUserList,    //获取负责人
        getJobB2BList,          //获取B2B工单列表
    } from "@/service/job";
    import {
    getAdminUser, //获取销售列表 
    } from "@/service/salesStatistics";
    import {
        optionsArea,        //省市区
    } from "@/service/area";
    import { 
        getStorageUserRoleId,
        getActionData
    } from '@/utils/store'
   
    export default {
        components:{
            RefuseUserList
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
              
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    JobStep: 0,             //工单进度
                    SubJobStep:0,            //子工单进度
                    JobId: '',              //工单id
                    JobNo: '',              //工单编号
                    IsProjectJob:0,//项目类别
                    Title: '',              //标题
                    SenderUserName: '',     //发单方用户名称
                    CreateTime: [],         //时间
                    ExecStartDate:[],//上门开始时间
                    ExecEndDate:[], //上门结束时间
                    JobStatus: '',          //工单状态
                    AdminUserId: '',        //对接人id
                    IsFreeToB2b:0,
                    SupaiSaleAdminUserId:'' //速派销售
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
                // 地区
                areaShow: false,
                region: '', 
                regionForm: {
                    ProvinceId: '', //省
                    CityId: '', //市
                },
                ProvinceIdList: [],
                CityIdList: [],
                // select
                stepArr: [
                    {
                    "JobStep": 0,
                    "ParentJobStep": 0,
                    "JobStepName": "全部",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 2,
                    "ParentJobStep": 0,
                    "JobStepName": "待审核",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 18,
                    "ParentJobStep": 0,
                    "JobStepName": "报价中",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 19,
                    "ParentJobStep": 0,
                    "JobStepName": "报价审核中",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 3,
                    "ParentJobStep": 0,
                    "JobStepName": "待支付押金",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 4,
                    "ParentJobStep": 0,
                    "JobStepName": "匹配中",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 8,
                    "ParentJobStep": 0,
                    "JobStepName": "服务中",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 10,
                    "ParentJobStep": 0,
                    "JobStepName": "报告待审核",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 11,
                    "ParentJobStep": 0,
                    "JobStepName": "待同意付款",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 12,
                    "ParentJobStep": 0,
                    "JobStepName": "待支付尾款",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 13,
                    "ParentJobStep": 0,
                    "JobStepName": "已完成",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 17,
                    "ParentJobStep": 0,
                    "JobStepName": "挂起",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 20,
                    "ParentJobStep": 0,
                    "JobStepName": "已关闭",
                    "JobCount": 0
                    },
                    {
                    "JobStep": 21,
                    "ParentJobStep": 0,
                    "JobStepName": "已取消",
                    "JobCount": 0
                    }
                ],            //头部进度
                stepArr2: [],            //列表里的进度
                statusArr:[],           //select 工单状态
                djrArr: [{"UserId":0,"RealName":'全部'},{"UserId":-1,"RealName":'无对接人'}],             //负责人
                supaiSaleUserData: [{"AdminUserId":0,"RealName":'全部'}],//速派销售
                refuseDrawer:false,
                refuseJobId:0
            };
        },
        // activated(){
        //     this.handleSearch()
        // },
       created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            // this.GetJobStatusListFun();
            this.GetTakeOverUserListFun();
            this.GetAdminUserData();
            
            var that=this;
        
            //获取头部的进度,不带数量
            // this.GetJobStepListFun(1,0,data=>{
            //     console.log("获取列表step1");
            //     console.log("data1:"+JSON.stringify(data))
            //     that.stepArr = data;
            // }); 
 
            //获取头部的进度，带数量
            // this.GetJobStepListFun(1,1,data=>{
            // // this.GetJobStepListFun(1,1,data=>{
            //     console.log("获取列表step2");
            //     console.log("data2:"+JSON.stringify(data))
            //     that.stepArr = data;
            // }); 
              
             //获取下拉框里面的进度
            this.GetJobStepListFun(0,0,data=>{
                that.stepArr2 = data;
            });

            // console.log("stepArr2:"+JSON.stringify(that.stepArr2))
            this.handleSearch()
        },
        
        methods: {
            // 获取工单列表分类
            GetJobStepListFun(isJobList,isJobCount,callback){
                var dataArr={
                    JobType:6,
                    IsJobCount:isJobCount,
                    IsJobList:isJobList
                };
                getJobStepList(dataArr).then(res=> { 
                    callback&&callback(res.Data);
                });
            },

            // 获取工单状态
            GetJobStatusListFun(){
                getJobStatusList().then(res=> {
                    this.statusArr = res.Data
                })
            },

            // 获取对接人
            GetTakeOverUserListFun(){
                getTakeOverUserList().then(res=> {
                    this.djrArr =[...this.djrArr,...res.Data];
                })
            },
             //获取速派销售
            async GetAdminUserData() {
                var data = { RoleCodeArray: ["XSJL", "XSZG"] };
                let res = await getAdminUser(data);
                if (res.Result != 1) {
                    return this.$message.error("获取销售失败请联系开发人员");
                }
                this.supaiSaleUserData = [...this.supaiSaleUserData,...res.Data.UserList]  ;
                },
            // 分类
            handleSearchType(type){
                this.form.JobStep = type
                this.form.SubJobStep =0;
                this.handleSearch()
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form);
             
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.regionForm = {
                    ProvinceId: '', //省
                    CityId: '', //市
                    XianId: '', //区
                }
                this.region = ''
                this.form = JSON.parse(JSON.stringify(this.oraginForm));

                // console.log('stepArr:'+JSON.stringify(this.stepArr));
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetJobB2BListFun()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetJobB2BListFun()
            },
            //获取我的客户列表
            async GetJobB2BListFun(){

                if(this.searchData.JobId)
                {
                    if (!/^\d+$/.test(this.searchData.JobId)) {
                        return this.$message.error("工单Id请输入数字");
                    }
                }

                var that=this;
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.JobId && delete data.JobId
                !data.JobNo && delete data.JobNo
                !data.Title && delete data.Title
                 data.ProvinceId = this.regionForm.ProvinceId.aid
                 data.CityId = this.regionForm.CityId.aid
                !data.ProvinceId && delete data.ProvinceId
                !data.CityId && delete data.CityId
                !data.SenderUserName && delete data.SenderUserName
                !data.AdminUserId && delete data.AdminUserId
                !data.SupaiSaleAdminUserId && delete data.SupaiSaleAdminUserId
                if (data.CreateTime && data.CreateTime.length) {
                    data.StartCreateTime = data.CreateTime[0]  
                    data.EndCreateTime = data.CreateTime[1]  
                }
                if (data.ExecStartDate && data.ExecStartDate.length) {
                    data.ExecStartDateStart = data.ExecStartDate[0]  
                    data.ExecStartDateEnd = data.ExecStartDate[1] 
                }
                delete data.ExecStartDate

                if (data.ExecEndDate && data.ExecEndDate.length) {
                    data.ExecEndDateStart = data.ExecEndDate[0]  
                    data.ExecEndDateEnd = data.ExecEndDate[1] 
                }
                delete data.ExecEndDate

                !data.JobStatus && delete data.JobStatus
                // !data.IsFreeToB2b && delete data.IsFreeToB2b
                // console.log("data:"+JSON.stringify(data))
                let res = await getJobB2BList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.JobList
                this.total = res.Data.TotalCount
 
                this.GetJobStepListFun(1,1,data=>{
                    // console.log("GetJobStepListFun stepArr:"+JSON.stringify(data ));
                    if(data)
                    {
                        that.stepArr = data
                    }
                }); 
            },
            // 地区
            isRegionShow(){
                this.areaShow = true
                this.$nextTick(()=>{
                    this.getAreaDataByParentFun(0,1)
                })
            },
            // 点击省份
            ProvinceIdFun(){
                this.getAreaDataByParentFun(this.regionForm.ProvinceId.aid,2)
                this.regionForm.CityId = {aid : '',areaname: ''}
            },
            // 点击地址确定
            submitAddressFun(){
                if(this.regionForm.CityId.areaname) {
                    this.region = this.regionForm.ProvinceId.areaname + this.regionForm.CityId.areaname
                }else{
                    this.region = this.regionForm.ProvinceId.areaname 
                }
                this.areaShow = false
            },
            //获取地址
            async getAreaDataByParentFun(id,hier){
                let data = {
                    aid: id,
                    areaType: hier
                }
                let res = await optionsArea(data)
                    switch(hier){
                        case 1:
                            this.ProvinceIdList = res.Data
                            break;
                        default:
                            this.CityIdList = res.Data
                            break;
                    }
            },
            // 跳转到客户信息
            linkjobInfoFun(id) {
                this.$router.push('./b2bJobInfo?JobId='+ id)
                // let routerUrl = this.$router.resolve({
                //     path: "/b2bJobInfo",
                //     query: {JobId: id}
                // })
                // window.open(routerUrl.href,'_blank')
            },
            SubStepChange(val)
            {
                console.log("val:"+val);
                var parentJobStep=0;
                for(var i=0;i<this.stepArr2.length;i++)  
                {
                    if(val==this.stepArr2[i].JobStep){
                        parentJobStep= this.stepArr2[i].ParentJobStep;
                    }
                }
                console.log("parentJobStep:"+parentJobStep);
                this.$nextTick(()=>{
                    this.form.JobStep=parentJobStep;
                });
            },
            //查看拒单信息
            viewRefuseInfo(jobId){ 
                console.log("jobId:"+jobId);
                this.refuseJobId=jobId;
                this.refuseDrawer = true;
                // console.log("refuseUserListRef:"+this.$refs.refuseUserListRef);
                 
                this.$nextTick(() => {
                    this.$refs.refuseUserListRef.open(jobId);
                }); 
            }

        }
    };
</script>
<style lang="scss">
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        // align-items: center;
        // border:1px solid red;
        .el-form-item {
            // border:1px solid blue;
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>